import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';

declare module '@stackflow/config' {
    interface Register {
        NotOperationModal: {};
    }
}

const NotOperationModal: ActivityComponentType<'NotOperationModal'> = () => {
    const { pop, replace } = useFlow();
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={24} align='center'>
                    <Text size='lg' align='center'>
                        현재 운영 중인 매장이 아닙니다.<br/>
                        다른 매장에서 주문하시겠습니까?
                    </Text>
                    <Row fullWidth spacing={10}>
                        <Button onClick={pop}
                            fullWidth
                            variant='secondary'>
                            취소
                        </Button>
                        <Button fullWidth
                            onClick={() => replace('ShopListActivity', { type: 'LIST', isOrder: true })} >
                            확인
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default NotOperationModal;
